import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { withNamespaces } from "react-i18next";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-2.svg";
import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";
import { ReactComponent as Sort } from "assets/icons/sort.svg";
import { ReactComponent as Name } from "assets/icons/Name.svg";
import { ReactComponent as NewestActive } from "assets/icons/Newest-active.svg";
import { ReactComponent as NewestInActive } from "assets/icons/Newest-inactive.svg";
import { ReactComponent as PopularityActive } from "assets/icons/Popularity-active.svg";
import { ReactComponent as PopularityInActive } from "assets/icons/Popularity-inactive.svg";
import { ReactComponent as RelevanceActive } from "assets/icons/Relevance-active.svg";
import { ReactComponent as RelevanceInActive } from "assets/icons/Relevance-inactive.svg";
import { ReactComponent as LastPlayedActive } from "assets/icons/LastPlayed-active.svg";
import { ReactComponent as LastPlayedInActive } from "assets/icons/LastPlayed-inactive.svg";
import { ReactComponent as EditorsActive } from "assets/icons/Editors-active.svg";
import { ReactComponent as EditorsInActive } from "assets/icons/Editors-inactive.svg";

import { ShowMoreFilterComponent } from "component/filters";
import * as queryString from "query-string";
import { is } from "immutable";

import "containers/ShowMoreFilters/styles.scss";

class ShowMoreFilters extends Component {
  constructor(props) {
    super(props);
    this.accordionRef = createRef();
    this.onFilterClickHandler = this._onFilterClickHandler.bind(this);
    this.onFilterClearHandler = this._onFilterClearHandler.bind(this);
    this.fetchFilters = this._fetchFilters.bind(this);
    this.state = {
      activeFilter: props.activeFilter,
      sortExpanded: true,
    };
  }

  _fetchFilters(route, filters) {
    let params = new URLSearchParams();
    if (filters) {
      filters.forEach((filter) => {
        filter.get("values").forEach((value) => {
          if (value.get("toggled") === true) {
            params.append(filter.get("id"), value.get("id"));
          }
        });
      });
    }
    this.props.fetchFilters(route, params);
  }

  componentWillMount() {
    if (
      this.props.filtersLink &&
      !this.props.filters &&
      !this.props.filtersIsLoading
    ) {
      //this.fetchFilters(this.props.filtersLink);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeFilter !== this.props.activeFilter) {
      if (nextProps.activeFilter === "sortBy" && this.accordionRef.current) {
        this.accordionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
      this.setState({
        activeFilter: nextProps.activeFilter,
        sortExpanded: true,
      });
    }

    if (
      !is(nextProps.filters, this.props.filters) &&
      nextProps.filters &&
      this.props.filters &&
      !this.props.filtersIsLoading
    ) {
      //this.fetchFilters(nextProps.filtersLink, nextProps.filters);
    }

    if (
      !is(nextProps.filtersLink, this.props.filtersLink) &&
      nextProps.filtersLink &&
      this.props.refreshOnRouteChange
    ) {
      //this.fetchFilters(nextProps.filtersLink, nextProps.filters);
    }
  }

  _onFilterClickHandler(subCategory, value) {
    this.props.setActiveFilter(this.props.filtersLink, subCategory, value);
  }

  _onFilterClearHandler(subCategory) {
    this.props.clearFilterByCategory(
      this.props.filtersLink.get("rel"),
      subCategory,
    );
  }

  render() {
    const { t } = this.props;

    let filtersToRender = [];
    if (this.props.filters) {
      const categoryFilter = this.props.filters.find(f => f.get('id') === 'category');
      const gameTypeFilter = this.props.filters.find(f => f.get('id') === 'gameType');

      if (categoryFilter || gameTypeFilter) {
        const otherFilters = this.props.filters.filter(f => {
          const id = f.get('id');
          return id !== 'category' && id !== 'gameType';
        }).toArray();

        if (otherFilters.length > 0) {
          filtersToRender.push({ isCombined: false, filter: otherFilters[0] });
          filtersToRender.push({
            isCombined: true,
            categoryFilter: categoryFilter || null,
            gameTypeFilter: gameTypeFilter || null,
          });
          for (let i = 1; i < otherFilters.length; i++) {
            filtersToRender.push({ isCombined: false, filter: otherFilters[i] });
          }
        } else {
          filtersToRender.push({
            isCombined: true,
            categoryFilter: categoryFilter || null,
            gameTypeFilter: gameTypeFilter || null,
          });
        }
      } else {
        filtersToRender = this.props.filters.map(filter => ({ isCombined: false, filter }));
      }
    }

    return (
      <div>
        <div
          className={`show-more-filters-container ${
            this.props.activeFilter ? "visible" : ""
          } ${this.props.isMobile ? "mobile" : "desktop"} `}
          onClick={() => {
            this.setState({
              activeFilter: null,
            });
            this.props.onClose();
            this.props.showFilters(false);
          }}
        />
        <div
          data-testid="sort-and-filter-modal"
          className={`show-more-filters ${
            this.props.activeFilter ? "visible" : ""
          } ${this.props.isMobile ? "mobile" : "desktop"} ${
            this.props.searchQuick ? "search-quick" : ""
          }`}
          onClick={() => {
            this.setState({
              activeFilter: null,
            });
            this.props.onClose();
            this.props.showFilters(false);
          }}
        >
          <div
            className={`content  ${this.props.activeFilter ? "fade-in" : ""}`}
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <div className="content-main">
              <div className="header row nopadding">
                {this.props.isMobile && (
                  <div className="horizontal-bar">&nbsp;</div>
                )}
                <div
                  className="col-3 clear-all d-flex align-items-center"
                  onClick={this.onFilterClearAllHandler}
                >
                  {this.props.enableClearAll && <span>{t("clearAll")}</span>}
                </div>
                {this.props.filtersLink && (
                  <div className="col d-flex align-items-center">
                    <div className="w-100 text-center label" data-testid="sort-and-filter-title">
                      {this.props.filtersLink.get("name")}
                    </div>
                  </div>
                )}
                <div className="col-3 d-flex align-items-center">
                  <div
                    className="close-btn w-100 text-right"
                    data-testid="close-button"
                    onClick={() => {
                      this.setState({
                        activeFilter: null,
                      });
                      this.props.showFilters(false);
                      this.props.onClose();
                    }}
                  >
                    <span className="label">{t("close")}</span>
                  </div>
                </div>
              </div>

              <div className="body">
                {this.props.sorts && (
                  <div className="accordion sort">
                    <div className="accordion-item" ref={this.accordionRef}>
                      <div
                        className="accordion-header"
                        onClick={(event) => {
                          event.stopPropagation();
                          this.setState({
                            sortExpanded: !this.state.sortExpanded,
                          });
                        }}
                      >
                        <div className="accordion-button w-100">
                          <div className="row">
                            <div className="col">
                              <span className="filter-icon" data-testid="sort-by-icon">
                                <Sort />
                              </span>
                              <span data-testid="sort-by-section-title">{t("sortBy")}</span>
                            </div>
                            <div className="col-auto">
                              {!this.state.sortExpanded && (
                                <ArrowDown />
                              )}
                              {this.state.sortExpanded && (
                                <ArrowUp />
                              )}
                            </div>
                          </div>
                          {!this.state.sortExpanded && (
                            <div className="sub">
                              {this.props.sorts.map((sort) => {
                                return this.props.sortBy === sort.get("id")
                                  ? sort.get("name")
                                  : null;
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className={`accordion-collapse collapse ${
                          this.state.sortExpanded ? "show" : ""
                        }`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div
                            className="row no-padding sort"
                            role="group"
                            aria-label="Basic outlined example"
                          >
                            {this.props.sorts.map((sort, key) => {
                              let Icon;
                              let isToggled =
                                this.props.sortBy === sort.get("id");

                              switch (sort.get("id")) {
                                case "name":
                                  Icon = Name;
                                  break;
                                case "newest":
                                  Icon = isToggled
                                    ? NewestActive
                                    : NewestInActive;
                                  break;
                                case "editor":
                                  Icon = isToggled
                                    ? EditorsActive
                                    : EditorsInActive;
                                  break;
                                case "lastPlayed":
                                  Icon = isToggled
                                    ? LastPlayedActive
                                    : LastPlayedInActive;
                                  break;
                                case "relevance":
                                  Icon = isToggled
                                    ? RelevanceActive
                                    : RelevanceInActive;
                                  break;
                                default:
                                  Icon = isToggled
                                    ? PopularityActive
                                    : PopularityInActive;
                              }

                              return (
                                <div
                                  className={`col-4 sort-by text-center ${
                                    this.props.sortBy === sort.get("id")
                                      ? "toggled"
                                      : ""
                                  }`}
                                  key={key}
                                  data-testid={`sort-option-${sort.get("id")}`}
                                >
                                  <div
                                    className="d-flex justify-content-center align-items-center"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      this.props.setCategorySorting(
                                        this.props.filtersLink,
                                        sort.get("id"),
                                      );
                                    }}
                                  >
                                    <div className="icon">
                                      <Icon />
                                      <div className="category-name">
                                        {sort.get("name")}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {filtersToRender.length > 0 && (
                  <div className="accordion">
                    {filtersToRender.map((item, index) => {
                      if (item.isCombined) {
                        return (
                          <ShowMoreFilterComponent
                            key="categoryGameType"
                            categoryFilter={item.categoryFilter}
                            gameTypeFilter={item.gameTypeFilter}
                            isVisible={this.props.activeFilter}
                            activeFilter={this.state.activeFilter}
                            setActiveFilter={(value) => {
                              this.setState({ activeFilter: value });
                            }}
                            onFilterClickHandler={this.onFilterClickHandler}
                            category={this.props.filtersLink.get("rel")}
                          />
                        );
                      } else {
                        const filter = item.filter;
                        if (filter.get("values").size === 1) {
                          return null;
                        }
                        return (
                          <ShowMoreFilterComponent
                            filter={filter}
                            key={filter.get('id')}
                            isVisible={this.props.activeFilter}
                            activeFilter={this.state.activeFilter}
                            setActiveFilter={(value) => {
                              this.setState({ activeFilter: value });
                            }}
                            onFilterClickHandler={this.onFilterClickHandler}
                            isMultiSelectable={filter.get("isMultiSelectable")}
                            filterSearch={(value) => {
                              let category = this.props.filtersLink.get("rel");
                              let subCategory = filter.get("id");
                              this.props.filterSearch(category, subCategory, value);
                            }}
                          />
                        );
                      }
                    })}
                  </div>
                )}
              </div>
              <div className="footer">
                <div className="row">
                  <div className="col text-center">
                    <span
                      className="badge badge-secondary"
                      data-testid="clear-all-button"
                      onClick={() => {
                        this.props.clearAllFilters(
                          this.props.filtersLink.get("rel"),
                        );
                      }}
                    >
                      {t("clearAll")}
                    </span>
                  </div>
                  <div className="col text-center">
                    <span
                      className="btn btn-danger"
                      data-testid="view-button"
                      onClick={() => {
                        this.setState({
                          activeFilter: null,
                        });
                        this.props.onClose();
                        this.props.showFilters(false);
                      }}
                    >
                      {t("view")}
                      <span data-testid="view-count">
                        {this.props.games
                          ? ` (${this.props.games.get("totalCount")})`
                          : ""}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { searchQuick } = queryString.parse(window.location.search);
  let filters;
  let sorts;
  let sortBy;
  let filtersIsLoading;

  try {
    filters = state.filters.getIn([
      ownProps.filtersLink.get("rel"),
      "data",
      "filters",
    ]);
    filtersIsLoading = state.filters.getIn([
      ownProps.filtersLink.get("rel"),
      "isLoading",
    ]);
    sorts = state.filters.getIn([
      ownProps.filtersLink.get("rel"),
      "data",
      "sorts",
    ]);
    sortBy = state.filters.getIn([
      ownProps.filtersLink.get("rel"),
      "data",
      "sortBy",
    ]);
  } catch (err) {}

  return {
    isMobile: state.window.get("isMobile"),
    filters,
    filtersIsLoading,
    sorts,
    sortBy,
    searchQuick,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    filterSearch: (category, subCategory, value) =>
      dispatchProps.filterSearch(category, subCategory, value),
    clearAllFilters: (category) => dispatchProps.clearAllFilters(category),
    fetchFilters: (route, params) => dispatchProps.fetchFilters(route, params),
    showFilters: (bol) => dispatchProps.showFilters(bol),
    setCategorySorting: (route, sorting) =>
      dispatchProps.setCategorySorting(route, sorting),
    setActiveFilter: (category, subCategory, filter) =>
      dispatchProps.setActiveFilter(category, subCategory, filter),
    logout: () => dispatchProps.logout(),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withNamespaces("translation")(ShowMoreFilters));
